/* Sesh — staggered scroll reveal for homepage sections (fail-safe: never leaves content hidden) */
(function () {
  function reveal(el) { el.classList.add('sesh-in'); }
  function init() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
    var targets = sections.slice(1); // never hide the hero
    if (!targets.length) return;
    targets.forEach(function (el) { el.classList.add('sesh-reveal'); });

    if (!('IntersectionObserver' in window)) { targets.forEach(reveal); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    // reveal anything already in or just below the viewport on load
    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      targets.forEach(function (el) {
        if (el.classList.contains('sesh-in')) return;
        if (el.getBoundingClientRect().top < vh * 1.05) { reveal(el); io.unobserve(el); }
      });
    }
    revealInView();
    window.addEventListener('load', revealInView);
    // ultimate safety net — content is never permanently hidden
    setTimeout(function () { targets.forEach(reveal); }, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
